<template>
  <el-card
    v-if="card && card.id"
    class="card-agree-buttons"
    style="margin-top: 20px"
  >
    <div style="display: flex; justify-content: space-between;">
      <div class="card-agree-buttons-text" style="font-size: 24px">Решение</div>
      <div>
        <el-popconfirm
          v-if="$canAndRulesPass(card, 'card.delete')"
          confirm-button-text='Да'
          cancel-button-text='нет'
          icon="el-icon-question"
          title="Вы уверены, что хотите удалить карту?"
          @confirm="deleteCard(card)"
        >
          <el-button
            style="margin-right: 20px"
            slot="reference"
            type="danger"
          >
            Удалить карту
          </el-button>
        </el-popconfirm>
        <el-button
          v-if="$can(card, 'card.disagree') && $rulesPass(card, 'card.disagree') && this.card.status !== this.$constants.card.statuses.STATUS_COMPLETED"
          type="danger"
          icon="fas fa-undo"
          :loading="loading"
          @click="disagreeNegotiation"
        >
          Отправить на доработку
        </el-button>
        <el-button
          v-if="$can(card, 'card.agree') && this.card.status !== this.$constants.card.statuses.STATUS_COMPLETED"
          :disabled="!$rulesPass(card, 'card.agree')"
          type="success"
          icon="fas fa-check"
          :loading="loading"
          @click="agreeNegotiation"
        >
          <span v-if="currentNegotiation && currentNegotiation.type === 'self'">Отправить на согласование</span>
          <span v-else>Согласовать</span>
        </el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import {mapGetters} from "vuex";
import CommentsBlock from "@/components/comments/CommentsBlock.vue";

export default {
  name: "agree-buttons",
  components: { CommentsBlock },
  props: {},
  computed: {
    ...mapGetters('card', {
      card: 'card',
    }),
    ...mapGetters('card/stages', {
      currentStage: 'currentStage',
      currentNegotiation: 'currentNegotiation',
    }),
    ...mapGetters('card/errors', {
      cardWarnings: 'warnings',
    }),
  },
  data() {
    return {
      loading: false,
    }
  },
  mounted() {},
  methods: {
    agreeNegotiation(){
      if( this.cardWarnings.length ){
        let message = 'В карте присутствуют следующие предупреждения:<br><br>';
        this.cardWarnings.forEach(warning => {
          message += warning.errorText + '<br>';
        })
        message += '<br>Вы уверены, что хотите продолжить?';
        this.$confirm(message, 'Внимание', {
          confirmButtonText: 'Да',
          cancelButtonText: 'нет',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.sendAgreeNegotiation();
        })
      } else {
        this.sendAgreeNegotiation();
      }
    },
    sendAgreeNegotiation(){
      this.loading = true;
      this.$api.card.agreeCard({
        card_id: this.card.id
      })
        .then((data) => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Этап успешно сохранен'
          });
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('card/loadCard');
        })
    },
    disagreeNegotiation(){
      this.loading = true;
      this.$api.card.disagreeCard({
        card_id: this.card.id
      })
        .then((data) => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Этап успешно сохранен'
          });
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('card/loadCard');
        })
    },
    deleteCard(card) {
      this.loading = true;
      this.$api.card.delete({
        id: card.id
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Карта успешно удалена'
          });
        })
        .finally(() => {
          if (this.card.card_next_and_previous_ids && this.card.card_next_and_previous_ids.nextId) {
            const queryParams = this.$route.query;

            this.$router.push({
              name: 'Card',
              params: { id: this.card.card_next_and_previous_ids.nextId },
              query: queryParams,
            }).then(() => {
              window.location.reload();
            });
          } else {
            this.$router.push({
              name: 'Cards',
            }).then(() => {
              window.location.reload();
            });
          }
        })
    },
  }
}
</script>

<style lang="scss">

</style>